import React from "react";
import "./contactus.scss";
import { addDoc, collection } from "@firebase/firestore"
import { db } from "../../firebase_setup/firebase"
import { useRef } from 'react';
import Navbar  from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
const Index = () => {



  return (
    <div>
      <Navbar/>
    <div className="contact">
      <h1 className="account-deletion-heading">Account Deletion</h1>
      <div className="process-step">
        <h3>Process Steps : </h3>
        <p>
          Steps : Download Freshpage Applicat Application from App Stores &#62;
          &#62; Login to your account &#62; &#62; Go to Settv vmfgings Page &#62;
          &#62; Select Privacy &#62; &#62; Select delete account{" "}
        </p>
      </div>
      <div className="or-button">
        <button className="button">or</button>
      </div>
      <div className="fill-up-form">
        <h3>Fill up Form : </h3>
        <p>
          Please Fill Up Below Form and will send you Verification link Once it
          Verified will remove your Data from our System
        </p>

        <div className="account-details-form">
          <div className="account-detail">
            <h4>Address & Details</h4>
            <div className="input-tag">
              <input type="text" placeholder="Name" />
              <input type="text" placeholder="Office" />
              <input type="text" placeholder="City" />
              <input type="text" placeholder="Address" />
              <input type="text" placeholder="Email" />
              <input type="text" placeholder="Zip/Postal Code" />
              <input type="reset" className="button" value="Submit" ></input>
              {/* <button >Submit</button> */}
            </div>
          </div>
          <div className="verify-number">
            <h4>Verify Number</h4>
            <div className="mobile-tag">
              <input type="text" placeholder="Mobile Number" />
            </div>
            <p>
              Four digits code are sent to (**)*** - 513. Enter the codes to
              verify your account.
            </p>
            <div className="otp-input">
              <input className="otp" maxLength={1} />
              <input className="otp" maxLength={1} />
              <input className="otp" maxLength={1} />
              <input className="otp" maxLength={1} />
            </div>
            <button>reset code</button>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default Index;
